import { catalogueRequest } from 'location/locality'
import type { GetServerSidePropsContext } from 'next'
import type { FC } from 'react'

import { mainPageAPI, statisticsAPI } from '../axios/axios'
import HomePage from '../home'
import type {
  IEventsBody,
  INewsBody,
  IProgramsBody,
  IStatistics,
} from '../home/HomePageContent/Body/Body'

interface IHomeProps {
  programsData: IProgramsBody[]
  newsData: INewsBody[]
  eventsData: IEventsBody[]
  statisticsData: IStatistics | null
}

const Home: FC<IHomeProps> = ({
  programsData,
  eventsData,
  newsData,
  statisticsData,
}) => (
  <HomePage
    statisticsData={statisticsData}
    programData={programsData}
    eventsData={eventsData}
    newsData={newsData}
  />
)

export default Home

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const request = catalogueRequest(context)
  if (request.redirect) return { redirect: request.redirect }
  const [programs, events, news, statistics] = await Promise.allSettled([
    mainPageAPI.getPrograms(request.params),
    mainPageAPI.getEvents(request.params),
    mainPageAPI.getNews(),
    statisticsAPI.statistics(),
  ])

  const results = [
    ['programs', programs],
    ['events', events],
    ['news', news],
    ['statistics', statistics],
  ] as const
  results.forEach(([name, result]) => {
    if (result.status === 'rejected') {
      console.error(`Home page ${name} request failed`)
    }
  })

  return {
    props: {
      programsData:
        programs.status === 'fulfilled' ? programs.value.data.data ?? [] : [],
      eventsData:
        events.status === 'fulfilled' ? events.value.data.data ?? [] : [],
      newsData: news.status === 'fulfilled' ? news.value.data.data ?? [] : [],
      statisticsData:
        statistics.status === 'fulfilled'
          ? statistics.value.data ?? null
          : null,
    },
  }
}
